import { color } from 'asserts/styles/colors';
import styled from 'styled-components';
import { Address } from './Address';
import { useNavigate, Link } from 'react-router-dom';
import * as S from 'components/join/Step1';
import { font } from 'asserts/styles/fonts';

export const Footer = () => {
  const footerData = [
    { title: '엑스바디홈페이지', link: 'https://exbody.kr/' },
    { title: '카카오채널', link: 'https://pf.kakao.com/_PTXNd' },
    { title: '유튜브', link: 'https://www.youtube.com/@exbody' },
    { title: '블로그', link: 'https://blog.naver.com/exbodyclub' }
  ];
  const footerData1 = [
    { title: '카카오톡문의', link: 'https://pf.kakao.com/_PTXNd' },
    { title: '이메일문의', link: 'https://www.exbody.co.kr/bbs/qawrite.php' },
    { title: '원격지원', link: 'https://www.898.tv/exbody' }
  ];
  const footerData2 = [
    { title: '회원가입', link: 'https://biz.exbody.com/login' },
    { title: '프로그램 다운로드', link: '/download' }
  ];

  const footerData3 = [
    { title: '서비스이용약관', link: '/terms/service' },
    { title: '개인정보처리방침', link: '/terms/individual' }
  ];

  const navigate = useNavigate();

  return (
    <Wrppaer>
      <LinkWrapper>
        <ul>
          {footerData.map((item) => (
            <li key={item.title}>
              <a target="_blank" href={item.link} rel="noreferrer">
                {item.title}
              </a>
            </li>
          ))}
        </ul>
        <ul>
          {footerData1.map((item) => (
            <li key={item.title}>
              <a target="_blank" href={item.link} rel="noreferrer">
                {item.title}
              </a>
            </li>
          ))}
        </ul>
        <ul style={{ fontSize: '14px' }}>
          {footerData2.map((item) => (
            <li key={item.title}>
              <Link to={item.link}>{item.title}</Link>
            </li>
          ))}
        </ul>
      </LinkWrapper>
      <TextWrapper>
        <div>
          {footerData3.map((item) => (
            <p key={item.title} onClick={() => navigate(`${item.link}`)}>
              {item.title}
            </p>
          ))}
        </div>
        <div>
          <p>
            본 프로그램에 게시된 이메일 주소가 전자우편 수집 프로그램이나그 밖의 기술적 장치를
            이용하여 무단으로 수집되는 것을 거부하며 이를 위반 시 정보통신망 이용촉진 및 정보보호
            등에 관한 법률에 의해 형사처벌됨을 유념하시기 바랍니다.
          </p>
          <p>
            ※ 만일, 위와같은 기술적 조치를 사용한 이메일주소무단수집 피해를 당하신 경우
            불법스팸대응센터 전용전화(국번없이02-1336)나홈페이지(www.spamcop.or.kr)의신고 창을
            통하여 신고하기 바랍니다.
          </p>
        </div>
      </TextWrapper>
      <div></div>
      <LineWrapper>
        <S.Line />
      </LineWrapper>
      <Address />
    </Wrppaer>
  );
};

const Wrppaer = styled.div`
  width: 1440px;
  margin: 0 auto;
  padding: 48px;
  background: ${color.navyLight};
  color: ${color.white};
`;

const LinkWrapper = styled.div`
  display: flex;
  gap: 128px;
  padding-bottom: 64px;

  & ul {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  & a {
    color: ${color.white2};
    ${font.caption1_medium};
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  & div:first-of-type {
    display: flex;
    gap: 32px;
  }

  & div:last-of-type {
    display: flex;
    flex-direction: column;
    gap: 8px;

    p {
      color: ${color.opacityWhite06};
      ${font.caption3_regular};
    }
  }

  & p {
    color: ${color.white2};
    ${font.caption2_regular};
  }
`;

const LineWrapper = styled.div`
  p {
    margin: 16px 0;
    background: ${color.opacityWhite02};
  }
`;
